import { render, staticRenderFns } from "./resolve-transmittal-dialog.vue?vue&type=template&id=70246ed9"
import script from "./resolve-transmittal-dialog.vue?vue&type=script&lang=js"
export * from "./resolve-transmittal-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports